import React from "react"
import { Redirect } from "react-router-dom"


import Logout from "pages/Authentication/Logout"
import Login from "../pages/AuthenticationInner/Login"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"



import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"


import Dashboard from "pages/Dashboard"
import BrandList from "pages/Brand/brands-list"
import MerchantList from "pages/Merchants/merchants-list"
import MerchantGroupList from "pages/Merchant-Group/merchants-group-list"
import BrandDetail from "pages/Brand/brand-detail"
import AddBrand from "pages/Brand/add-brand"
import MerchantGroupDetail from "pages/Merchant-Group/merchant-group-detail"
import MerchantDetail from "pages/Merchants/merchant-detail"

// Offers
import CuratorOffersList from "pages/Offers/curator-offers-list"
import OperationOffersList from "pages/Offers/operation-offers-list"
import ApproverOffersList from "pages/Offers/approver-offers-list"
import PublishedOffersList from "pages/Offers/published-offers-list"
import OfferDetail from "pages/Offers/offer-detail"
import UserProfile from "pages/Authentication/user-profile"

// Users
import UsersList from "pages/Users/users-list"

const authProtectedRoutes = [

    { path: "/profile", component: UserProfile },

    { path: "/dashboard", component: Dashboard },

    //Brand
    { path: "/brands", component: BrandList },
    { path: "/brands/add-brand", component: AddBrand },
    { path: "/brands/:id", component: BrandDetail },

    //Merchant
    { path: "/merchants", component: MerchantList },
    { path: "/merchants/add-merchant", component: MerchantDetail },
    { path: "/merchants/:id", component: MerchantDetail },

    //Merchant Group
    { path: "/merchant-groups", component: MerchantGroupList },
    {
        path: "/merchant-groups/add-merchant-group",
        component: MerchantGroupDetail,
    },
    {
        path: "/merchant-groups/:id",
        component: MerchantGroupDetail,
    },

    // Offers
    { path: "/curator-offers", component: CuratorOffersList },
    { path: "/curator-offers/add-offer", component: OfferDetail },
    { path: "/curator-offers/:id", component: OfferDetail },
    { path: "/operation-offers", component: OperationOffersList },
    { path: "/operation-offers/:id", component: OfferDetail },
    { path: "/approver-offers", component: ApproverOffersList },
    { path: "/approver-offers/:id", component: OfferDetail },
    { path: "/published-offers", component: PublishedOffersList },
    { path: "/published-offers/:id", component: OfferDetail },

    // Users
    { path: "/users", component: UsersList },

    // this route should be at the end of all other routes
    // eslint-disable-next-line react/display-name
    { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const publicRoutes = [
    { path: "/logout", component: Logout },
    { path: "/pages-404", component: Pages404 },
    { path: "/pages-500", component: Pages500 },

    // Authentication Inner
    { path: "/login", component: Login },
    { path: "/forgot-password", component: Recoverpw },

]

export { authProtectedRoutes, publicRoutes }
